const brandDiscountButton = document.getElementById("brand-discount-confirm");
const brandPopupTriggers = document.querySelectorAll(
    ".lux-brand[data-toggle='lux-popup']",
);
const modalBrandNavLinks = document.querySelectorAll(
    ".brand-discount-modal .brand-nav-link",
);

if (brandDiscountButton) {
    brandDiscountButton.addEventListener("click", function (event) {
        event.preventDefault();

        const brandId = this.getAttribute("data-brand-id");
        const brandDiscountToast = document.querySelector(
            ".toast-brand-discount",
        );

        fetch("/add-brand-discount", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-TOKEN": "{{ csrf_token() }}",
            },
            body: JSON.stringify({
                brand_id: brandId,
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    document
                        .querySelectorAll(".brand-discount-modal")
                        .forEach((el) => el.classList.remove("active"));

                    if (brandDiscountToast) {
                        luxPopup.toastShow(brandDiscountToast);
                    }

                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: "customer_brand_discount_added",
                        brand_name: data.brand,
                        eventCallback: function () {
                            window.location.reload();
                        },
                    });

                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                } else {
                    throw new Error(data.message);
                }
            })
            .catch((error) => {
                throw new Error(error);
            });
    });
}

if (brandPopupTriggers) {
    brandPopupTriggers.forEach(function (brand) {
        brand.addEventListener("click", function () {
            let brandName = brand.getAttribute("data-brand-name") ?? "";
            let brandImg = brand.getAttribute("data-brand-img") ?? "";
            let brandLink = brand.getAttribute("data-brand-link") ?? "";
            let brandId = brand.getAttribute("data-brand-id") ?? "";

            const brandNameEl = document.getElementById("brand-discount-name");
            if (brandNameEl) {
                brandNameEl.textContent = brandName;
            }

            const toastNameEl = document.getElementById(
                "toast-brand-discount-name",
            );
            if (toastNameEl) {
                toastNameEl.textContent = brandName;
            }

            const brandImgEl = document.getElementById("brand-discount-img");
            if (brandImgEl) {
                brandImgEl.setAttribute("src", brandImg);
                brandImgEl.setAttribute("alt", brandName);
            }

            const confirmEl = document.getElementById("brand-discount-confirm");
            if (confirmEl) {
                confirmEl.setAttribute("data-brand-id", brandId);
            }
        });
    });
}

if (modalBrandNavLinks) {
    modalBrandNavLinks.forEach((link) => {
        link.addEventListener("click", function (e) {
            e.preventDefault();

            let targetId = link.getAttribute("data-target");
            let targetElement = /** @type {HTMLElement | null} */ (
                document.querySelector(`.brand-discount-modal #${targetId}`)
            );

            if (!targetElement) return;

            targetElement.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        });
    });
}
